<template>
  <div>
    <v-dialog v-model="cepDialog" max-width="450px">
      <Cep
          @reaload="reaload"
          :cepProps="address.cep"
      ></Cep>
    </v-dialog>
    <!-- Mobile Bar-->
    <v-app-bar
      v-if="isMobile"
      app
      height="115"
      flat
      color="#FFFFFF"
      style="position: relative"
    >
      <div class="d-flex flex-column">
        <div class="d-flex">
          <v-app-bar-nav-icon
            large
            color="#BC0000"
            @click="drawer = !drawer"
          ></v-app-bar-nav-icon>

          <v-spacer></v-spacer>

          <router-link to="/home">
            <v-img
                max-width="150"
                src="../../assets/imprimax_logo.png"
                alt="IMPRIMAX"
                class="pointer"
                contain
            ></v-img>
          </router-link>

          <v-spacer></v-spacer>

          <v-divider vertical class="ma-2 my-4"></v-divider>

          <v-spacer></v-spacer>

          <div class="mr-4 pt-4" v-if="user && user.id && user.type == 3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    @click="goToRoute('/profile', 5)"
                    class="magnify-expand"
                    size="28"
                    color="#bc0000"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-magnify-expand
                </v-icon>
              </template>
              <span>Buscador imprimax</span>
            </v-tooltip>
          </div>

          <Avatar :user="user" />

          <v-btn
            icon
            large
            class="hidden-md-and-up"
            color="normalred"
            @click="goToRoute('/cart')"
          >
            <v-badge color="black" :content="badge" :value="badge" overlap>
              <v-icon> mdi-cart-outline</v-icon>
            </v-badge>
          </v-btn>
        </div>

        <v-card
          class="pa-0 ma-0"
          style="border-radius: 0 !important"
          elevation="0"
          color="#bc0000"
          align="center"
        >
          <v-combobox
            height="40px"
            outlined
            dense
            ref="myComboBox"
            hide-details
            style="
              margin: 10px;
              border-radius: 6px !important;
              background: #ffffff;
              width: 88% !important;
            "
            v-model="filter.product"
            :items="items"
            placeholder="O que você procura?"
            return-object
            v-on:keyup.enter="advancedSearch"
            :search-input.sync="search"
          >
            <template v-slot:append>
              <v-icon
                icon
                class="pt-0"
                color="normalred"
                size="26"
                @click="advancedSearch"
                >mdi-magnify
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Resultados para "<strong>{{ search }}</strong
                    >". Pressione <kbd>enter</kbd> para continuar com a procura
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-card>
      </div>
    </v-app-bar>

    <!-- Mobile Lateral Bar-->
    <v-navigation-drawer
      v-if="isMobile && drawer"
      v-model="drawer"
      color="#FFFFFF"
      app
      temporary
      :mini-variant.sync="mini"
      width="80%"
      mini-variant-width="110"
      style="margin-top: 54px; border-radius: 0 0 20px 0;"
    >
      <br />
      <div
        class="mx-2 nav"
        v-if="
          category &&
          category.subCategoriesToCategory &&
          category.subCategoriesToCategory.length > 0 &&
          showOnlySubcategories
        "
      >
        <a
          class="d-flex align-center justify-start ml-4 mb-3 pointer"
          @click="toCleanSubCategories"
        >
          <v-img
            max-width="20"
            src="../../assets/voltar.svg"
            alt="IMPRIMAX"
            class="pointer"
            contain
          ></v-img>

          <strong class="text_departamentos ml-3"> Voltar</strong>
        </a>

        <strong class="categoryName ml-4">{{
          category.categoryName.toUpperCase()
        }}</strong>

        <v-list-group
          v-for="(subcategory, idx) in category.subCategoriesToCategory"
          :key="idx"
          class="pa-0 ma-0 not_border_item"
          @click="goToSubCategory(subcategory.subCategory)"
        >
          <template v-slot:activator>
            <v-list-item-content
              class="nav-icon title-menu"
              :class="
                idx < category.subCategoriesToCategory.length - 1
                  ? 'border_item'
                  : ''
              "
            >
              <v-list-item-title
                class="mb-2"
                v-if="subcategory.subCategory.name"
              >
                <a
                    class="link-subcategory-name"
                    :href="generateLinkSubCategory(subcategory)"
                >
                  {{ subcategory.subCategory.name.toUpperCase() }}
                </a>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-group>

        <a
            class="text-center ver_tudo"
            :href="generateLinkCategory(category.categoryName)"
        >
          <p class="text-center ver_tudo pt-3">
            Ver tudo em {{ category.categoryName.toUpperCase() }}
          </p>
        </a>
      </div>

      <div v-else class="mx-2 nav">
        <a
            class="d-flex mb-2 align-center"
            @click="cepDialog = true"
            v-if="address && address.cep"
        >
          <v-icon size="18" color="#BC0000">
            mdi-map-marker
          </v-icon>
          <span class="text_departamentos">Calculando para: {{ address.cep }}</span>
        </a>
        <strong class="text_departamentos ml-3" @click="goToRoute('/profile')">
          Meus Pedidos
        </strong>

        <v-divider class="my-3"></v-divider>

        <strong class="text_departamentos ml-3">Departamentos</strong>

        <template v-if="loadingCategories">
          <v-skeleton-loader
            v-for="n in 7"
            :key="'sk-cat-mobile-' + n"
            type="list-item"
            class="skeleton-menu-mobile"
          ></v-skeleton-loader>
        </template>

        <template v-else>
        <v-list-group
          v-for="(category, idx) in categories"
          :key="idx"
          offset-y
          open-on-hover
          class="pa-0 ma-0"
          @click="setSubCategories(category)"
        >
          <template v-slot:activator>
            <v-list-item-content
              class="nav-icon title-menu"
              :class="idx < categories.length - 1 ? 'border_item' : ''"
              style="text-align-last: left"
            >
              <div class="d-flex align-center justify-space-between">
                <v-list-item-title v-text="category.categoryName.toUpperCase()">
                </v-list-item-title>

                <v-icon color="#4F4F4F" size="30">mdi-chevron-right</v-icon>
              </div>
            </v-list-item-content>
          </template>
        </v-list-group>
        </template>

        <div class="container_contato mx-2 mb-5">
          <p class="text_departamentos mt-6">Canais de Atendimento</p>

          <div class="phone d-flex align-end mb-4">
            <v-img
              max-width="20"
              src="../../assets/phone.svg"
              alt="IMPRIMAX"
              class="pointer"
              @click="goToRoute('/home')"
              contain
            ></v-img>
            <span class="ml-3 " style="font-size: 16px">
              +55 11 2101-4244
            </span>
          </div>

          <div class="phone d-flex align-end mb-4">
            <v-img
                max-width="20"
                src="../../assets/phone.svg"
                alt="IMPRIMAX"
                class="pointer"
                @click="goToRoute('/home')"
                contain
            ></v-img>
            <a
                class="link_phone_menu ml-3"
                href="https://api.whatsapp.com/send?1=pt_BR&phone=5511945059235"
                target="_blank"
            >
              +55 11 94505-9235
            </a>
          </div>

          <div class="phone d-flex align-end mb-4">
            <v-img
              max-width="20"
              src="../../assets/email.svg"
              alt="IMPRIMAX"
              class="pointer"
              @click="goToRoute('/home')"
              contain
            ></v-img>
            <a class="link_phone_menu ml-3"> marketplace@imprimax.com.br </a>
          </div>

          <div class="phone d-flex align-end">
            <v-img
              max-width="20"
              src="../../assets/localizacao.svg"
              alt="Localização"
              class="pointer"
              @click="goToRoute('/home')"
              contain
            ></v-img>
            <a class="link_phone_menu ml-3">
              Rua Karam Simão Racy, 49 <br />São Paulo - SP - Brasil
            </a>
          </div>
        </div>

        <div class="container_contato mb-5">
          <p class="text_departamentos mx-2 mt-6">Outros</p>

          <v-list-group
            v-for="(link, idx) in linksOutros"
            :key="idx"
            offset-y
            open-on-hover
            class="pa-0 ma-0"
            style="margin-left: -10px !important"
          >
            <template v-slot:activator>
              <v-list-item-content
                class="title-menu"
                :class="idx < linksOutros.length - 1 ? 'border_item' : ''"
              >
                <div class="d-flex">
                  <v-list-item-title>
                    <a
                      v-if="link.name === 'Central do vendedor'"
                      class="link-central-vendedor-mobile link_phone_menu"
                      :href="`${link.link}`"
                      target="_blank"
                    >
                      {{ link.name }}
                    </a>

                    <a
                        v-else
                        class="link-central-vendedor-mobile link_phone_menu"
                        @click="toNavegation(link.link)"
                    >
                      {{ link.name }}
                    </a>
                  </v-list-item-title>
                  <v-icon color="#4F4F4F" size="30">mdi-chevron-right</v-icon>
                </div>
              </v-list-item-content>
            </template>
          </v-list-group>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- Desktop Bar-->
    <v-app-bar
      class="d-flex flex-column align-center"
      v-if="!isMobile"
      app
      flat
      height="auto"
      width="100%"
      color="#FFFFFF"
      style="z-index: 11!important;"
    >
      <div class="imx-inner">
        <!-- Logo -->
        <router-link to="/home" class="imx-logo">
          <v-img
            max-width="140"
            src="../../assets/imprimax_logo.png"
            alt="IMPRIMAX"
            class="pointer"
            contain
          ></v-img>
        </router-link>

        <!-- Busca -->
        <div class="imx-search">
          <v-combobox
            solo
            flat
            hide-details
            class="imx-search-input"
            item-text="productName"
            v-model="filter.product"
            :items="items"
            ref="myComboBox"
            placeholder="Busque por produto, material ou código"
            v-on:keyup.enter="advancedSearch"
            :search-input.sync="search"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Resultados para "<strong>{{ search }}</strong
                    >". Pressione <kbd>enter</kbd> para continuar com a procura
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

          <v-btn
            tile
            depressed
            height="46"
            min-width="56"
            color="#c4161c"
            class="imx-search-btn"
            @click="advancedSearch"
          >
            <v-icon color="#FFFFFF">mdi-magnify</v-icon>
          </v-btn>
        </div>

        <!-- CEP -->
        <v-btn
          depressed
          height="auto"
          color="#f4f4f4"
          class="imx-cep text-none"
          @click="cepDialog = true"
        >
          <span class="imx-cep-content">
            <v-icon color="#c4161c" size="22" class="mr-2">mdi-map-marker</v-icon>
            <span class="imx-txt">
              <small>Calculando para:</small>
              <strong>{{ address && address.cep ? address.cep : 'Escolha o CEP' }}</strong>
            </span>
          </span>
        </v-btn>

        <!-- Ações -->
        <div class="imx-nav">
          <v-tooltip bottom v-if="user && user.id && user.type == 3">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  @click="goToRoute('/profile', 5)"
                  class="magnify-expand"
                  size="30"
                  color="#c4161c"
                  v-bind="attrs"
                  v-on="on"
              >
                mdi-magnify-expand
              </v-icon>
            </template>
            <span>Buscador imprimax</span>
          </v-tooltip>

          <Avatar :user="user" />

          <a class="imx-item" @click="goToRoute('/profile')">
            <v-icon color="#c4161c" size="26">mdi-package-variant-closed</v-icon>
            <span class="imx-txt">
              <small>Acompanhe</small>
              <strong>Meus pedidos</strong>
            </span>
          </a>

          <a class="imx-cart" @click="goToRoute('/cart')" aria-label="Carrinho">
            <v-badge color="#c4161c" :content="badge" :value="badge" overlap>
              <v-icon color="#1f1f1f" size="28">mdi-cart-outline</v-icon>
            </v-badge>
          </a>
        </div>
      </div>

      <div class="container_category d-flex justify-center">
        <v-card
          elevation="0"
          class="barra-superior pa-0 ma-0"
          v-if="this.$route.path !== '/login'"
        >
          <template v-if="loadingCategories">
            <div
              v-for="n in 7"
              :key="'sk-cat-' + n"
              class="title-menu-desktop pr-3 d-flex align-center"
            >
              <v-skeleton-loader
                type="text"
                width="80"
                class="skeleton-menu-desktop"
              ></v-skeleton-loader>
            </div>
          </template>

          <template v-else>
          <v-menu
            v-for="(category, idx) in categories"
            :key="idx"
            offset-y
            open-on-hover
            rounded="b-xl"
          >
            <template  v-slot:activator="{ on, attrs }">
              <v-list-item-content
                class="title-menu-desktop pr-3"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-title
                    class="list-item-title"
                >
                  <a
                      class="link-category-name"
                      :href="generateLinkCategory(category.categoryName)"
                  >
                    {{category.categoryName.toUpperCase()}}
                  </a>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list
              class=""
              width="340"
              max-height="500"
              style="margin-top: 0px!important;"
               v-if="category.categoryName.toUpperCase() !== 'HOME'"
            >
              <v-list-item
                class="menu-list"
                style="
                  background-color: #ffffff;
                  color: #4f4f4f !important;
                 "
                v-for="(subcategory, index) in category.subCategoriesToCategory"
                :key="index"
                link
              >
                <v-list-item-title
                  class="menu-list-item"
                  :class="
                    index < category.subCategoriesToCategory.length - 1
                      ? 'border_item'
                      : ''
                  "
                  v-if="subcategory.subCategory.name"
                >
                  <a
                      class="link-subcategory-name"
                      :href="generateLinkSubCategory(subcategory)"
                  >
                    {{ subcategory.subCategory.name.toUpperCase() }}
                  </a>
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                  class="menu-list"
                  style="
                  background-color: #ffffff;
                  color: #4f4f4f !important;
                 "
              >
                <v-list-item-title class="menu-list-item">
                  <a
                      class="text-center ver_tudo"
                      :href="generateLinkCategory(category.categoryName)"
                  >
                    <p class="text-center ver_tudo pt-2">
                      Ver tudo em {{ category.categoryName.toUpperCase() }}
                    </p>
                  </a>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          </template>
        </v-card>
      </div>
    </v-app-bar>
  </div>
</template>

<style>
.magnify-expand{
  cursor: pointer;
}
.nav {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 90vh;
  box-sizing: border-box;
}
.max_width_container_header {
  width: 90% !important;
}

.header_desktop_logo_search_profile {
  align-items: center;
  height: 85px !important;
  justify-content: space-between;
}

.header_desktop_search {
  background: #f2f2f2;
  border-radius: 6px;
  /*width: 25%!important;*/
}

.header_desktop_profile {
  display: flex;
  align-items: center;
  justify-content: end;
}

/* Header desktop (layout header-1a) */
.imx-inner {
  width: 90%;
  margin: 0 auto;
  height: 84px;
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 0;
}

.imx-logo {
  display: flex;
  align-items: center;
  flex: none;
}

.imx-search {
  flex: 1;
  display: flex;
  align-items: stretch;
  height: 46px;
  border: 1.5px solid #d6d6d6;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s;
}

.imx-search:focus-within {
  border-color: #c4161c;
}

.imx-search .imx-search-input {
  flex: 1;
  margin: 0;
  padding: 0;
  font-size: 15px;
}

.imx-search .imx-search-input .v-input__control,
.imx-search .imx-search-input .v-input__slot {
  min-height: 46px !important;
}

.imx-search .imx-search-input .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  margin: 0 !important;
  padding: 0 18px !important;
}

.imx-search .imx-search-btn.v-btn {
  border-radius: 0 !important;
  margin: 0 !important;
}

.imx-cep.v-btn {
  flex: none;
  border-radius: 8px !important;
  box-shadow: none !important;
  height: auto !important;
  min-height: 44px;
  padding: 8px 18px !important;
}

.imx-cep-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.imx-txt {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.imx-txt small {
  font-size: 11px;
  color: #6b6b6b;
  text-transform: none;
  letter-spacing: 0;
}

.imx-txt strong {
  font-size: 14px;
  font-weight: 600;
  color: #1f1f1f;
  text-transform: none;
  letter-spacing: 0;
}

.imx-nav {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: none;
}

.imx-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.imx-cart {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  cursor: pointer;
}

.imx-cart:hover {
  background: #f4f4f4;
}

.container_category {
  width: 100% !important;
  background: #bc0000 !important;
}

.text_meus_pedidos {
  color: #4f4f4f;
  font-size: 1.1rem;
  font-weight: 600;
}

.text_departamentos {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #bc0000;
}

.quantidade_carrinho {
  padding: 0 1px;
  color: #bc0000;
  font-size: 1.1rem;
  font-weight: 600;
}

.link_phone_menu {
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  color: #4f4f4f !important;
  text-decoration: none;
}

.link-central-vendedor-mobile {
  text-decoration: none;
  padding-left: -10px !important;
}

.menu-list:hover {
  cursor: pointer;
}

.menu-list-item {
  padding: 10px 2px !important;
}

.ver_tudo {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  color: #bc0000;
  text-decoration: none!important;
}

.pointer {
  cursor: pointer !important;
  transition: 0.2s !important;
}

.barra-superior {
  display: inline-flex !important;
  border-radius: 0 !important;
  justify-content: space-evenly !important;
  width: 90% !important;
  height: 42px !important;
  background: #bc0000 !important;
}

.categoryName {
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0;
  color: #4f4f4f;
}

.border_item {
  border-bottom: 1px solid #dedede;
  padding-bottom: 6px !important;
}

.not_border_item:last-child {
  border: none;
}

.container_contato {
  border-top: 1px solid #4f4f4f;
}

.v-toolbar__content {
  display: contents !important;
}

.v-list-item__icon {
  display: none !important;
  text-decoration: none !important;
}

.v-navigation-drawer--mini-variant,
.v-navigation-drawer {
  overflow: visible !important;
}

i.v-icon.notranslate.mdi.mdi-teach.theme--light.white--text.AplicadoresIcon {
  font-size: larger;
}

.v-navigation-drawer__content {
  overflow: visible !important;
}

.v-navigation-drawer__border {
  overflow: visible !important;
}

.v-toolbar__title {
  /* font-family: Poppins; */
  font-size: 1.5rem !important;
}

.title-menu {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0;
  text-align: left;
  padding: 0;
}

.v-list-group {
  -webkit-box-pack: center;
  justify-content: center;
}

.title-menu-desktop {
  text-align-last: left;
  font-style: normal !important;
  font-weight: bold !important;
  line-height: 28px !important;
  letter-spacing: 0.15px !important;
  color: #ffffff !important;
}

.list-item-title {
  padding-top: 3px !important;
  border-bottom: 3px solid #bc0000;
}

.list-item-title:hover {
  padding-top: 3px !important;
  border-bottom: 3px solid #ffffff;
}

.link-category-name{
  color: #FFFFFF!important;
  text-decoration: none;
}
.link-subcategory-name{
  color:  #4F4F4F!important;
  text-decoration: none;
}

@media screen and (max-width: 1300px) {
  .max_width_container_header,
  .imx-inner,
  .barra-superior {
    width: 100% !important;
    padding: 0 10px;
  }
}

/* Skeletons do menu (categorias) */
.skeleton-menu-desktop .v-skeleton-loader__text {
  margin: 0 !important;
  background: rgba(255, 255, 255, 0.6);
}

.skeleton-menu-desktop {
  background: transparent !important;
}

.skeleton-menu-mobile {
  background: transparent !important;
}

/* No mobile, mostra só o ícone da conta (sem "Entrar / Cadastrar") */
@media screen and (max-width: 600px) {
  .imx-item .imx-txt {
    display: none;
  }
}
</style>

<script>
import Avatar from "../internal/Avatar";
import ApiService from "../../services/ApiService";
import FormatParamsUrl from "../../Utils/FormatParamsUrl";
import { parseString } from "xml2js";
import Cep from "../pages/components/Cep.vue";

export default {
  name: "Navigation",

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  async mounted() {
    this.baseUrl = window.location.origin
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
    await this.getCategories();
    this.subCategoriesToCategory = []; //Pick categories to mainMenu
    if (this.$route.query.produto) {
      this.search = this.$route.query.produto;
    }
    let address = localStorage.getItem("address_cep");
    if(address){
      this.address = JSON.parse(address)
    }
  },

  data: () => ({
    loadingCategories: true,
    filter: {
      product: "",
      categoria: "",
      page: 1,
      pageSize: 15,
      DocumentNumber: null,
      status: null,
      updated_at: null,
    },
    category: null,
    showOnlySubcategories: false,
    urlB2B: `${process.env.VUE_APP_BASE_URL_B2B_FRONT}/auth`,
    search: null,
    cepDialog: false,
    apiService: new ApiService(),
    items: [],
    badge: "",
    isMobile: false,
    drawer: false,
    user: {},
    mini: false,
    group: null,
    address: Object,
    categories: [],
    linksOutros: [
      {
        name: "Dúvidas Frequentes",

        link: `/perguntas-frequentes`,
      },
      {
        name: "Política de Troca e Devoluções",
        link: "/politicas/troca-devolucoes",
      },
      {
        name: "Política de Privacidade",
        link: "/politicas/politica-privacidade",
      },
      {
        name: "Termos e Condições",
        link: "/politicas/termos-condicoes",
      },
      {
        name: "Aplicadores Parceiros",
        link: "/installers",
      },
      {
        name: "Ser Aplicador Parceiro",
        link: "/add-installer",
      },
      {
        name: "Central do vendedor",
        link: `${process.env.VUE_APP_BASE_URL_B2B_FRONT}/auth`,
      },
      {
        name: "Sobre a Loja Imprimax",
        link: `/politicas/quem-somos`,
      },
    ],
    links: [
      {
        icon: "mdi-facebook",
        href: "https://www.facebook.com/ImprimaxAdesivos",
        text: "Facebook",
      },
      {
        icon: "mdi-instagram",
        href: "https://www.instagram.com/imprimaxadesivos/",
        text: "Instagram",
      },
      {
        icon: "mdi-linkedin",
        href: "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGwStGx-AGmFwAAAX4lnAz4_GxE6YsCz6cw4UbIneuVdpZBlBVmdEonNUW6RGEykkxa_Zg5l77EL2OJlMjc0_bhY5ydk56AdIwyvAlbQz1kJu-rUtodQ06x4k4zDraZsMxJaHI=&originalReferer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fimprimaxadesivos%2F",
        text: "Linkedin",
      },
      {
        icon: "mdi-whatsapp",
        href: "https://api.whatsapp.com/send?1=pt_BR&phone=5511945059235",
        text: "WhatsApp",
      },
      {
        icon: "mdi-youtube",
        href: "https://www.youtube.com/user/ImprimaxVideos",
        text: "Youtube",
      },
      {
        icon: "mdi-pinterest",
        href: "https://br.pinterest.com/imprimaxadesivos/",
        text: "Pinterest",
      },
      {
        icon: "mdi-soundcloud",
        href: "https://soundcloud.com/podcast-do-adesivo",
        text: "SoundCloud",
      },
    ],
    baseUrl: null
  }),

  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));

    if (this.user) {
      this.getCart();
    } else {
      const cart = JSON.parse(localStorage.getItem("cart"));
      this.badge = 0;
      if (cart) {
        cart.items.forEach((item) => {
          this.badge += item.quantity;
        });
      }
    }


    this.$root.$on("changeBadge", (data) => {
      if (data) {
        const cart = JSON.parse(localStorage.getItem("cart"));
        this.badge = 0;
        cart.items.forEach((item) => {
          this.badge += item.quantity;
        });
      } else {
        if (this.user) {
          this.getCart();
        }
      }
    });
  },

  components: {
    Cep,
    Avatar,
  },
  computed: {

  },
  methods: {
    generateLinkCategory(categoryName){
      const categoryParse = categoryName.replace(/ /g, "-").toLowerCase();
      if(categoryName.toString().toLowerCase() === "home"){
        return `${this.baseUrl}/${categoryParse}`
      }

      if(categoryName.toString().toLowerCase() === "cursos"){
        return `${this.baseUrl}/cursos`
      }
      return `${this.baseUrl}/categoria/${categoryParse}`
    },

    generateLinkSubCategory(subCategory){
      if(subCategory.course) {
        return `${this.baseUrl}/cursos/categoria/${subCategory.subCategory.linkSearch}`
      }
      const subCategoryNameParse = FormatParamsUrl.format(subCategory.subCategory.name);
      return `${this.baseUrl}/subcategorias/${subCategoryNameParse}`
    },

    reaload(){
      this.cepDialog = false;
      window.location.reload();
    },

    toNavegation(to) {
      this.$router.push(
          {
            path: to
          }
      )
      this.$root.$emit("platform-policies");
    },

    getCart() {
      this.apiService.get("cart", true, false).then((response) => {
        this.badge = response.content.itemsQuantity;
      });
    },

    toCleanSubCategories() {
      this.showOnlySubcategories = false;
      this.category = [];
    },

    setSubCategories(category) {
      const rotaAtual = this.$route.name;
      if (
        category.categoryName.toString().toLowerCase() === "home" &&
        rotaAtual !== category.categoryName
      ) {
        this.$router.push({ name: "Home" });
        return;
      }
      this.category = category;
      this.showOnlySubcategories = true;
    },

    homeNav(category) {
      const rotaAtual = this.$route.name;
      if (
        category.toString().toLowerCase() === "home" &&
        rotaAtual !== category
      ) {
        this.$router.push({ name: "Home" });
      }
    },

    ifHome(category) {
      if (category.toString().toLowerCase() === "home") {
        this.$router.push({ name: "Home" });
      } else if (category.toString().toLowerCase() === "cursos") {
        this.$router.push({ name: "Courses" });
      } else {
        let cat = category.replace(/ /g, "-").toLowerCase();
        this.$router.push({ path: `/categoria/${cat}` });
        this.$root.$emit("rechargeCategory");
      }
    },
    async getCategories() {
      try {
      await this.apiService
        .post(`category/menuActive`, this.filter, null, true, false)
        .then(async (response) => {
          response.categories.forEach((e) => {
            this.categories.push(e);
          });
          const {content} = await this.apiService.get(`categoryCourses`, this.filter, false)
          this.categories.unshift(...[
            {
              categoryCode: "",
              categoryId: 1,
              categoryInventory: "",
              categoryName: "Home",
              products: null,
              statusOnMenu: true,
              subCategoriesToCategory: {},
            },
            {
              categoryCode: "",
              categoryId: 2,
              categoryInventory: "",
              categoryName: "Cursos",
              products: null,
              statusOnMenu: true,
              subCategoriesToCategory: content.map((x) => {
                return {
                  subCategoryId: x.id,
                  course: true,
                  subCategory: {
                    subCategoryId: x.id,
                        ...x,
                    course: true,
                  }
                }
              }),
            }
          ]);
        })
        .catch((err) => {
        });
      } finally {
        this.loadingCategories = false;
      }
    },
    filtrar() {
      this.$root.$emit("filtroMudado", this.filter.product);
    },
    async advancedSearch() {
      this.$refs["myComboBox"].blur();
      await this.$router
        .push({
          path: "/produtos",
          query: {
            produto: this.search,
          },
        })
        .catch((error) => {});
      this.$root.$emit("advancedSearch");
    },
    async getAutocomplete() {
      await this.apiService
        .post(`product/listActiveB2C`, this.filter)
        .then((response) => {
          this.products = response.products;
        });
    },

    async goToRoute(route, step = null) {
      if (this.$route.path !== route) {
        if(step){
          localStorage.setItem("step", JSON.stringify(step))
        }
        await this.$router.push(route);
      }
    },
    async goToSubCategory(subcategory) {
      const name = FormatParamsUrl.format(subcategory.name);
      if(subcategory.course){
        await this.$router.push({
          path: `/cursos/categoria/${name}`,
        });
        this.$root.$emit("rechargeSubcategory");
        return
      }
      await this.$router.push({
        path: `/subcategorias/${name}`,
      });
      this.$root.$emit("rechargeSubcategory");
    },

    hasAccess(val) {
      const result = val.find((type) => this.user.type == type);

      return result != undefined;
    },

    onResize() {
      this.isMobile = window.innerWidth < 960;
    },

    async goTo(path, config) {
      if (path !== this.$route.path && path !== "" && config !== "true") {
        await this.$router.push(path);
        this.drawer = false;
      }

      if (path !== this.$route.path && path !== "" && config == "true") {
        await this.$router.push({
          path: `/resaleconfig?id=` + item.id + `&profile=` + item.name,
          params: item,
        });
      }
    },
  },
  watch: {
    isMobile() {
      if (!this.isMobile) {
        window.location.reload(false);
      }
    },
  },
};
</script>
